import classnames from 'clsx';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { player } from 'src/client/player';
import { PLAYER_MANAGER_ENABLED } from 'src/common/constants/experiments/config';
import useActions from 'src/common/hooks/useActions';
import useExperiment from 'src/common/hooks/useExperiment';
import { useStores } from 'src/common/providers';
import { selectPlaybackRate } from 'src/common/selectors/player';
import { changePlaybackRateIfPossible } from '../../../actions/tuner';
import cssVariables from '../../../styles/variables';
import Checkmark from '../../shared/svgIcons/Checkmark';
import css from './playback-rate-option.module.scss';

export default function PlayBackRateOption({ value, className }) {
  const legacySelectedRate = useSelector(selectPlaybackRate);
  const actions = useActions({ changePlaybackRateIfPossible });
  const isPlayerManagerEnabled = useExperiment(PLAYER_MANAGER_ENABLED);
  const { playerStore } = useStores();
  const playerManagerPlaybackRate = playerStore.playbackRate();
  const selectedRate = isPlayerManagerEnabled ? playerManagerPlaybackRate : legacySelectedRate;
  const formattedPlaybackRate = `${value.toString().padEnd(3, '.0')}x`;

  return (
    <div
      className={classnames(css.value, className)}
      onClick={() =>
        player.isActive
          ? player.setPlaybackRate(value)
          : actions.changePlaybackRateIfPossible(value, true)
      }
    >
      {formattedPlaybackRate}
      {value === selectedRate && (
        <Checkmark
          width="40px"
          height="40px"
          viewBox="0 0 30 30"
          fill={cssVariables['--secondary-color-5']}
        />
      )}
    </div>
  );
}

PlayBackRateOption.propTypes = {
  value: PropTypes.number,
  legacySelectedRate: PropTypes.number,
  className: PropTypes.string,
  actions: PropTypes.object.isRequired,
};
